import Vue from "vue";
import Vuex from "vuex";
import ProductService from "../services/ProductService";
import createPersistedState from "vuex-persistedstate";
import SellerService from "../services/SellerService";
import { uuid } from 'vue-uuid';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state: {
    isLoading: false,
    shop: {},
    products: [],
    currentProduct: {},
  },
  mutations: {
    SET_SHOP(state, shop) {
      state.shop = shop;
    },
    SET_PRODUCTS(state, products) {
      state.products = products;
    },
    SET_CURRENT_PRODUCT(state, product) {
      var array = product.images.split(";");
      product.cover = array[0] + '?version=' + uuid.v1();
      state.currentProduct = product;
    },
  },
  actions: {
    GET_SHOP_INFO({ commit }, params) {
      SellerService.getShopInfo(params).then((res) => {
        commit("SET_SHOP", res.data);
      });
    },

    GET_ALL_PRODUCTS({ commit }, params) {
      ProductService.getAll(params).then((res) => {
        var products = res.data;
        for (var i = 0; i < products.length; i += 1) {
          var array = products[i].images.split(";");
          products[i].cover = array[0] + '?version=' + uuid.v1();
        }
        commit("SET_PRODUCTS", products);
      });
    },

    GET_CURRENT_PRODUCT({ commit }, params) {
      return ProductService.get(params).then((res) => {
        commit("SET_CURRENT_PRODUCT", res.data);
      });
    },
  },
});
